module.exports = __webpack_public_path__ + "static/media/tuse-stranut.e77a2975.jpeg";